import script from "./auditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./auditDialog.vue?vue&type=script&setup=true&lang=js"

import "./auditDialog.vue?vue&type=style&index=0&id=01891114&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01891114"]])

export default __exports__